module.exports = __webpack_public_path__ + "static/media/steamy-dream.be3c0d34.png";